import { Reference } from 'firebase/database';
import * as moment from 'moment';
import { Component, h } from 'preact';
import { connect } from 'preact-redux';
import Counter from '../../components/counter';
import POTW from '../../components/potw';
import { storage, db } from '../../firebase';
import { ConnectedReduxProps } from '../../store';
import { loadCounter } from '../../store/counter/actions';
import { loadPOTW } from '../..//store/potw/actions';
import { POTWState } from '../../store/potw/types';

const style = require('./style.less');

export class Home extends Component<ConnectedReduxProps<void>, any> {
    counterRef: Reference;
    potw: Reference;

    componentDidMount() {
        this.counterRef = db.ref(`counters/main`);

        this.counterRef!.on('value', (snapshot) => {
            let val: number = snapshot.val();
            this.props.dispatch(loadCounter('main', val));
        });

        this.potw = db.ref('potw/main');

        this.potw!.on('value', (snapshot) => {
            let val = snapshot.val();
            return storage.refFromURL(val.url)
                .getDownloadURL()
                .then((url) => {
                    let potw: POTWState = {
                        url,
                        description: val.description,
                        width: val.width,
                        height: val.height
                    };
                    this.props.dispatch(loadPOTW(potw));
                });
        });

        fetch('/api/1/counters/increment/main', {method: 'POST'});
    }

    componentWillUnmount() {
        this.counterRef!.off();
        delete this.counterRef;

        this.potw!.off();
        delete this.potw;
    }

    render() {
        return (
            <div class={ style.message }>
                <img src="/assets/ga.png?2" class={ style.logo }
                     alt="Geeks Anonymous - If only everything came with pulldown menus and online help."
                />

                <h2>Welcome to Geeks Anonymous</h2>

                <p>
                    Online, technically, since 1994 (serving geeks for { moment('1994-09-01T14:00:00Z').fromNow(true) }).
                </p>

                <p>
                    Last website update of any real content was { moment('2009-04-26T06:43:03Z').fromNow() }.
                    Hit counters were all the rage back then, so
                    this website in its current form has been loaded <Counter name="main" words />.
                </p>

                <p class={ style.small }>
                    The above logo is an original logo from around 1999. Nice, right?
                </p>

                <a href="https://slepp.ca/">Head over to Slepp's main site</a>

                <POTW />
            </div>
        );
    }
}

export default connect()(Home);



// WEBPACK FOOTER //
// ./routes/home/index.tsx